import api from "services/api";

// Get regularization requests
export const getRegularizations = async (params) => {
  return api.get("/v1/api/attendance/regularizations", {
    params,
  });
};

// Approve regularization request
export const approveRegularization = async (id) => {
  return api.put(`/v1/api/attendance/regularization/${id}/action`, {
    action: "approved",
    check_in_method: "regularization", //because Subhankar da's backend code shows         "message": "Data truncated for column 'check_in_method' at row 1",
  });
};

// Reject regularization request
export const rejectRegularization = async (id, rejectionReason) => {
  return api.put(`/v1/api/attendance/regularization/${id}/action`, {
    action: "rejected",
    rejection_reason: rejectionReason,
  });
};
